import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

// FIX: helper reads token at call-time, not at module-load time
// Prevents stale token after re-login without page reload
function getAuthHeaders() {
    const user = JSON.parse(localStorage.getItem("user"));
    return {
        'Authorization': "Bearer " + user?.Token,
        "Accept": "*/*",
    };
}

export const getQuatationBuilder = createAsyncThunk(
    "quatationOperasional/getBuilder",
    async ({}, thunkAPI) => {
        try {

            const response = await axios.get(
                process.env.REACT_APP_API_URL+'getQuatationBuilder',
                { headers: getAuthHeaders() }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getQuatationOperasional = createAsyncThunk(
    "quatationOperasional/get",
    async ({start, count, search, QuatationNo}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", "");
        formData.append("count", "");
        formData.append("search", "");
        formData.append("QuatationNo", QuatationNo);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getQuatation',
                formData,
                {
                    headers: getAuthHeaders()
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getMJS = createAsyncThunk(
    "getMJS/get",
    async ({tanggal1, tanggal2, QuatationNo}, thunkAPI) => {
        let formData = new FormData();
        formData.append("QuatationNo", QuatationNo);
        formData.append("tanggal1", tanggal1);
        formData.append("tanggal2", tanggal2);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMJS2',
                formData,
                {
                    headers: getAuthHeaders()
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const getMjsV2 = createAsyncThunk(
    "getMjsV2/get",
    async ({tanggal1, tanggal2, QuatationNo}, thunkAPI) => {
        let formData = new FormData();
        formData.append("QuatationNo", QuatationNo);
        formData.append("tanggal1", tanggal1);
        formData.append("tanggal2", tanggal2);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + 'getMjsV2',
                formData,
                {headers: getAuthHeaders()}
            )
            if (response.status === 200) {
                return response.data;
            }
            return thunkAPI.rejectWithValue(response.data);
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response?.data);
        }
    }
)


export const getQuatationMonitoring = createAsyncThunk(
    "quatationOperasional/getMonitoring",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMonitoringQuatation',
                formData,
                {
                    headers: getAuthHeaders()
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const GetMonitoringQuatationSpec = createAsyncThunk(
    "quatationOperasional/GetMonitoringQuatationSpec",
    async ({start, count, search, jenis}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        formData.append("jenis", jenis);


        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'GetMonitoringQuatationSpec',
                formData,
                {
                    headers: getAuthHeaders()
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const GetMonitoringQuatationSpecMin = createAsyncThunk(
    "quatationOperasional/GetMonitoringQuatationSpecMin",
    async ({}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", 0);
        formData.append("count", 100000);
        formData.append("search", "");
        formData.append("jenis", 1);


        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'GetMonitoringQuatationSpec',
                formData,
                {
                    headers: getAuthHeaders()
                }
            )
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.QuatationNo,
                        label: item.QuatationNo,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const insertQuatationOperasional = createAsyncThunk(
    "quatationOperasional/insert",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertQuatation',
                data,
                {
                    headers: getAuthHeaders()
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const editQuatationOperasional = createAsyncThunk(
    "quatationOperasional/edit",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'editQuatation',
                data,
                {
                    headers: getAuthHeaders()
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isEditSuccess: false,
    isEditFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    errorMessage: "",
    mindata: [],
    isGetDetailMJS: false,
    mjsData: []
};

export const quatationOperasionalSlice = createSlice({
    name: "quatationOperasional",
    initialState,
    reducers: {
        resetQuotation: (state) => {
            state.isGetSuccess = false;
            state.isGetFetching = false;
            state.isGetError = false;
            state.data = null;
            state.count = 0;
            state.message = "";
        },
    },
    extraReducers: {
        [getQuatationBuilder.fulfilled]: (state, {payload}) => {
            state.isGetBuilderFetching = false;
            state.isGetBuilderSuccess = true;
            state.dataBuilder = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getQuatationBuilder.rejected]: (state, {payload}) => {
            state.isGetBuilderFetching = false;
            state.isGetBuilderError = true;
            state.errorMessage = payload.message;
        },
        [getQuatationBuilder.pending]: (state) => {
            state.isGetBuilderFetching = true;
        },

        [getQuatationOperasional.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.isGetDetailMJS = false;
            state.message = payload.message;
            return state;
        },
        [getQuatationOperasional.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getQuatationOperasional.pending]: (state) => {
            state.isGetFetching = true;
        },


        [GetMonitoringQuatationSpec.fulfilled]: (state, {payload}) => {
            state.isGetMonitoringFetching = false;
            state.isGetMonitoringSuccess = true;
            state.isEditSuccess = false;
            state.isEditSuccess = false;
            state.isGetSuccess = false;
            state.isInsertSuccess = false;
            state.dataMonitoring = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [GetMonitoringQuatationSpec.rejected]: (state, {payload}) => {
            state.isGetMonitoringFetching = false;
            state.isGetMonitoringError = true;
            state.errorMessage = payload.message;
        },
        [GetMonitoringQuatationSpec.pending]: (state) => {
            state.isGetMonitoringFetching = true;
        },


        [getQuatationMonitoring.fulfilled]: (state, {payload}) => {
            state.isGetMonitoringFetching = false;
            state.isGetMonitoringSuccess = true;
            state.isEditSuccess = false;
            state.isEditSuccess = false;
            state.isGetSuccess = false;
            state.isInsertSuccess = false;
            state.dataMonitoring = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getQuatationMonitoring.rejected]: (state, {payload}) => {
            state.isGetMonitoringFetching = false;
            state.isGetMonitoringError = true;
            state.errorMessage = payload.message;
        },
        [getQuatationMonitoring.pending]: (state) => {
            state.isGetMonitoringFetching = true;
        },

        // INSERT
        [insertQuatationOperasional.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            return state;
        },
        [insertQuatationOperasional.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertQuatationOperasional.pending]: (state) => {
            state.isInsertFetching = true;
        },

        [getMJS.fulfilled]: (state, {payload}) => {
            state.isGetDetailMJS = true;
            state.message = payload.message;
            state.mjsData = payload.data;
            return state;
        },
        [getMJS.rejected]: (state, {payload}) => {
            state.isGetDetailMJS = false;
            state.errorMessage = payload.message;
        },
        [getMJS.pending]: (state) => {
            state.isGetDetailMJS = false;
        },

        [getMjsV2.fulfilled]: (state, {payload}) => {
            state.isGetDetailMJS = true;
            state.message = payload.message;
            state.mjsData = payload.data;
            return state;
        },
        [getMjsV2.rejected]: (state, {payload}) => {
            state.isGetDetailMJS = false;
            state.errorMessage = payload?.message;
        },
        [getMjsV2.pending]: (state) => {
            state.isGetDetailMJS = false;
        },


        // EDIT
        [editQuatationOperasional.fulfilled]: (state, {payload}) => {
            state.isEditFetching = false;
            state.isEditSuccess = true;
            return state;
        },
        [editQuatationOperasional.rejected]: (state, {payload}) => {
            state.isEditFetching = false;
            state.isEditError = true;
            state.errorMessage = payload.message;
        },
        [editQuatationOperasional.pending]: (state) => {
            state.isEditFetching = true;
        },

        [GetMonitoringQuatationSpecMin.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.mindata = payload.data;
            return state;
        },
        [GetMonitoringQuatationSpecMin.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [GetMonitoringQuatationSpecMin.pending]: (state) => {
            state.isGetFetching = true;
        },

    },
});

export const { resetQuotation } = quatationOperasionalSlice.actions;

export const quatationOperasionalSelector = (state) => state.quatationOperasional;
